import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ListInstructorsOrTutorsDTO } from 'src/app/model/newModel';
import { ConstantsCLA } from '../../../shared/constants-cla';
import { SearchInstructorsOrTutorsCommand } from 'src/app/model/command-model';

@Injectable({
  providedIn: 'root',
})
export class InstructorsService {
  constructor(private http: HttpClient) {}

  search() {
    const command = new SearchInstructorsOrTutorsCommand();
    command.type = false;
    return this.http.post<ListInstructorsOrTutorsDTO>(
      ConstantsCLA.INSTRUCTORS_SEARCH_URL,
      command
    );
  }

  previousPage(skip: number, take: number) {
    const skipNew = skip - 1 < 0 ? 0 : skip - 1;
    const command = new SearchInstructorsOrTutorsCommand();
    command.type = false;
    command.skip = skipNew;
    command.take = take;
    return this.http.post<ListInstructorsOrTutorsDTO>(
      ConstantsCLA.INSTRUCTORS_SEARCH_URL,
      command
    );
  }

  nextPage(skip: number, take: number, count: number) {
    const skipNew = skip + 1;
    const command = new SearchInstructorsOrTutorsCommand();
    command.type = false;
    command.skip = skipNew;
    command.take = take;
    return this.http.post<ListInstructorsOrTutorsDTO>(
      ConstantsCLA.INSTRUCTORS_SEARCH_URL,
      command
    );
  }
}
